import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import './AuthPage.scss'

// Прозрачный пиксель: значение src, которое выбирают экраны уже 800px,
// где ни один source не подходит. Data URI не создаёт запроса.
const TRANSPARENT_PIXEL =
	'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

type PageProps = {
	children: ReactNode
}

// Обёртка для каждой страницы авторизации
function AuthPage(props: PageProps) {
	const { children } = props

	const { t } = useTranslation()

	return (
		<main className="auth-page">
			<div className="auth-page__left">
				<div className="auth-page__promo-wrapper">
					<div className="auth-page__promo-gradient">
						{/*
							Левая колонка скрыта до 800px, но display: none не отменяет
							загрузку картинки — на телефоне она занимала 638 КБ канала и
							задерживала LCP. Источники ограничены той же медиа-границей,
							поэтому на узких экранах грузится только прозрачная заглушка.
						*/}
						<picture>
							<source
								media="(min-width: 800px)"
								type="image/webp"
								srcSet="/images/illustrations/auth-cover-900.webp 900w, /images/illustrations/auth-cover-1400.webp 1400w"
								sizes="calc(50vw - 60px)"
							/>
							<source
								media="(min-width: 800px)"
								srcSet="/images/illustrations/auth-cover.png"
							/>
							<img
								src={TRANSPARENT_PIXEL}
								className="auth-page__promo"
								width={900}
								height={852}
								alt="promo"
							/>
						</picture>
					</div>
				</div>
				<p className="auth-page__slogan">{t('auth.slogan')}</p>
			</div>
			<div className="auth-page__right">{children}</div>
		</main>
	)
}

export default AuthPage
